import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute } from "@angular/router";
import { faThumbsUp } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-confirmemail',
  templateUrl: './confirmemail.component.html',
  styleUrls: ['./confirmemail.component.css']
})
export class ConfirmemailComponent implements OnInit {



  faThumbsUp = faThumbsUp;
  id;
  token;
  result;

  constructor(private http: HttpClient, private route: ActivatedRoute) { }

  ngOnInit(): void {

    let that = this;

    this.route.queryParams.subscribe(params => {
      that.id = params['id'];
      that.token = params['token'];
    });
  }



}
